export default __webpack_public_path__ + "static/media/foxit-member.010ee0cd.png";